'use client';

import { useEffect } from 'react';
import { AlertCircle } from 'lucide-react';

export default function ShopError({ error, reset }: {
    error: Error & { digest?: string };
    reset: () => void;
}) {

    useEffect(() => {
        console.error('Shop page error:', error);
    }, [error]);

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="flex flex-col items-center justify-center py-16">
                <div className="bg-red-100 rounded-full p-6 mb-4">
                    <AlertCircle className="w-16 h-16 text-red-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                    Something went wrong!
                </h2>
                <p className="text-gray-600 mb-6 text-center max-w-md">
                    We encountered an error while loading the shop. Please try again.
                </p>
                <button
                    onClick={reset}
                    className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                    Try Again
                </button>
            </div>
        </div>
    );
}